import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import styled from 'styled-components';

export const CreateNewFolderButton = styled(ButtonLoader)`
  max-width: 160px;
`;
